// extracted by mini-css-extract-plugin
module.exports = {"product-service-adds-on__service-message":"product-service-adds-on__service-message--7v3rm"};